module.exports = __webpack_public_path__ + "static/media/arrow.464b4ad3.svg";